import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FirebaseMessagingService } from './firebase-messaging.service';
import { UserService } from '../services/user.service';
import { Device } from '@capacitor/device';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Capacitor } from '@capacitor/core';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    public pushNotificationToken: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    public deviceToken: string | null = null;
    public isPushNotificationsAvailable = false;
    public permissionsGranted = false;
    public registrationError: string;

    private lastRegisteredToken: string | null = null;

    constructor(private readonly firebaseMessagingService: FirebaseMessagingService, private readonly userService: UserService, private readonly http: HttpClient) {
        this.firebaseMessagingService.onRegistration.subscribe(async token => await this.registerDevice(token));
    }

    public async registerDevice(token: string): Promise<void> {
        // Skip if we've already registered this token in this session
        if (this.lastRegisteredToken === token) {
            console.log('Device already registered with this token, skipping');
            return;
        }

        // Update local state
        this.deviceToken = token;
        this.pushNotificationToken.next(token);

        try {
            const deviceObject = await this.createDeviceObject(token);
            await this.http.post(`${environment.apiUrl}/devices/create`, deviceObject).toPromise();
            this.lastRegisteredToken = token;
            console.log('Device registered successfully');
        } catch (error) {
            console.error('Failed to register device:', error);
        }
    }

    private async createDeviceObject(token: string): Promise<{
        pushNotificationToken: string;
        deviceInfo: string;
        os: string;
        userId: number;
    }> {
        const userId = await this.userService.getActiveUserId();
        const os = Capacitor.getPlatform() ?? 'unknown';
        const deviceId = await Device.getId();

        return {
            pushNotificationToken: token,
            deviceInfo: deviceId.identifier,
            os: os,
            userId: userId
        };
    }

}
